import { Box, Skeleton, useTheme } from '@mui/material';
import React from 'react';

const MFAListSkeleton = ({ showHeader = true }) => {
  const theme = useTheme();
  
  return (
    <Box className="main_content_container">
      {/* Header Section with Key Icon and Title */}
      {showHeader && (
        <Box 
          className="d-flex align-items-center mt-4 p-3 main_content_container"
          sx={{
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.02)'
          }}
        >
          <Skeleton
            variant="rectangular"
            width={24}
            height={24}
            className="me-3"
            sx={{
              borderRadius: '50% 50% 50% 50% / 60% 60% 40% 40%',
            }}
          />
          <Skeleton variant="text" width={200} height={32} sx={{ fontSize: '1.5rem', fontWeight: '600' }} />
        </Box>
      )}

      <Box className="row h-100">
        {/* Left Sidebar Navigation */}
        <Box className="col-lg-3 col-md-4">
          <Box 
            className="p-3 rounded h-100 main_content_container"
            sx={{
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.01)'
            }}
          >
            {/* Navigation Items */}
            {[
              { icon: 'grid', text: 'Authenticator App', active: true },
              { icon: 'chat', text: 'SMS' },
              { icon: 'envelope', text: 'EMAIL' },
              { icon: 'grid', text: 'Miniorange Authenticator' },
              { icon: 'phone', text: 'Call Verification' },
              { icon: 'music', text: 'Hardware Token' },
              { icon: 'question', text: 'Security Question' },
            ].map((item, index) => (
              <Box
                key={index}
                className={`d-flex align-items-center p-2 mb-2 rounded ${item.active ? 'bg-primary text-white' : ''}`}
              >
                <Skeleton
                  variant="circular"
                  width={20}
                  height={20}
                  className="me-3"
                  sx={{ 
                    bgcolor: item.active ? 'rgba(255,255,255,0.7)' : undefined
                  }}
                />
                <Skeleton
                  variant="text"
                  width={item.text.length * 8}
                  height={20}
                  sx={{ 
                    bgcolor: item.active ? 'rgba(255,255,255,0.7)' : undefined
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>

        {/* Right Content Area */}
        <Box className="col-lg-9 col-md-8">
          <Box className="p-4 rounded h-100 main_content_container">
            {/* Top Bar */}
            <Box className="d-flex justify-content-between align-items-center mb-4">
              <Box className="d-flex align-items-center">
                <Skeleton variant="text" width={100} height={24} className="me-2" />
                <Skeleton variant="rectangular" width={120} height={32} style={{ borderRadius: '16px' }} />
              </Box>
              <Box className="d-flex align-items-center">
                <Skeleton variant="rectangular" width={50} height={24} className="me-2" />
                <Skeleton variant="text" width={200} height={20} />
              </Box>
            </Box>

            {/* Authenticator App Cards */}
            {[
              { name: 'Google Authenticator', configured: true },
              { name: 'Microsoft Authenticator', configured: false },
              { name: 'Authy Authenticator', configured: false },
            ].map((app, index) => (
              <Box 
                key={index} 
                className="border rounded p-3 mb-3"
                sx={{
                  borderColor: theme.palette.divider
                }}
              >
                <Box className="d-flex align-items-center justify-content-between">
                  <Box className="d-flex align-items-center">
                    {/* App Logo */}
                    <Skeleton
                      variant="rectangular"
                      width={40}
                      height={40}
                      className="me-3"
                      style={{ borderRadius: '8px' }}
                    />
                    <Skeleton variant="text" width={150} height={24} />
                  </Box>

                  <Box className="d-flex align-items-center">
                    {app.configured ? (
                      <>
                        <Skeleton variant="rectangular" width={50} height={24} className="me-2" />
                        <Skeleton variant="text" width={80} height={20} />
                      </>
                    ) : (
                      <Skeleton variant="text" width={80} height={20} />
                    )}
                  </Box>
                </Box>

                {/* Description */}
                <Box className="mt-2">
                  <Skeleton variant="text" width="100%" height={16} />
                  <Skeleton variant="text" width="80%" height={16} />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MFAListSkeleton;
